<template lang="pug">
  .ai-nlp-element
    b-card.mb-0.card-inactive.p-2(no-body)
      .bg-white.mb-3
        fieldset(:disabled="disabled")
          b-form-row.align-items-center.justify-content-end(v-if="!disabled")
            b-col
              span.text-sm.text-success(v-if="isNew") Nuevo
            b-col(cols="auto")
              x-icon.icon-md.hover-danger.pointer.text-secondary(@click="$emit('destroy', element_id)")
          b-form-row.mb-3
            b-col
              b-form-group(label="Modelo:", v-for="(e_a, e_a_index) in Element_Attributes", :key="e_a_index", v-if="e_a.name == 'model_id'", :id="`element_attribute_${e_a.element_attribute_id}`")
                k-select.disabled-white(placeholder="- Seleccionar modelo -", :options="parsedModels", :disabled="disabled", :value="e_a.value || null", @input="modelSelected(e_a, $event)")
            b-col
              b-form-group(label="Intención:", v-for="(e_a, e_a_index) in Element_Attributes", :key="e_a_index", v-if="e_a.name == 'intent'", :id="`element_attribute_${e_a.element_attribute_id}`")
                k-select.disabled-white(placeholder="- Seleccionar intención -", :options="parsedIntents", :disabled="disabled", :value="e_a.value || null", @input="updateElementAttribute(e_a, $event)")
          div(v-if="!disabled")
            b-form-group.mb-3(v-if="parsedEntities.length")
              p.mb-2.text-sm.text-secondary Agregar entidades:
              k-select(placeholder="- Seleccionar entidad -", :options="parsedEntities", v-model="selected_entity", @input="addEntity($event)", :clearable="true")
            p.mb-0.text-help.text-center(v-else) Este modelo no tiene entidades
          div(v-if="Entities.length")
            p.mb-2.text-sm.text-secondary Selecciona la variable donde se guardará la entidad seleccionada:
            .entity-element(v-for="(entity, entity_index) in Entities")
              b-form-row.align-items-end
                b-col
                  b-form-group
                    p.mb-2.text-primary {{ `${entity.entity}:` }}
                    k-select.disabled-white(placeholder="- Seleccionar variable -", :options="parsedUserAttributes", :disabled="disabled", :value="entity.user_attribute_id || null", @input="updateEntity(entity.entity, $event)")
                b-col(cols="auto", v-if="!disabled")
                  b-button(variant="soft-danger", @click="removeEntity(entity.entity)")
                    trash-2-icon.icon-sm
      template-element-connector(v-for="(connector, connector_index) in Element_Connectors", :key="connector_index", v-bind="connector", :block_id="block_id", element, :element_id="element_id", :template_id="template_id", :disabled="disabled")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import templateElementCommon from '@/helpers/template-element-common'
import Select from '@/components/Select.vue'
import Connector from '@/components/templates/connectors/Connector.vue'
import _debounce from 'lodash.debounce'

const accountController = createNamespacedHelpers('account')
const modelController = createNamespacedHelpers('model')

export default {
  mixins: [templateElementCommon],
  data () {
    return {
      model_intents: [],
      model_entities: [],
      selected_entity: null
    }
  },
  computed: {
    ...accountController.mapState({
      user_attributes: state => state.user_attributes
    }),
    ...modelController.mapState({
      models: state => state.models
    }),
    parsedUserAttributes () {
      return this.user_attributes.map(a => {
        return {
          label: a.name,
          id: a.user_attribute_id
        }
      })
    },
    parsedModels () {
      return this.models.map(m => {
        return {
          label: m.name,
          id: m.model_id
        }
      })
    },
    parsedIntents () {
      return this.model_intents.map(i => {
        return {
          label: i.name,
          id: i.name
        }
      })
    },
    parsedEntities () {
      return this.model_entities.map(i => {
        return {
          label: i.name,
          id: i.name
        }
      })
    },
    Entities () {
      let entities = this.getAttribute('entities')
      if (entities) {
        try {
          return JSON.parse(entities.value)
        } catch (e) {
          return []
        }
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions(['model/get']),
    getModel (model_id) {
      if (!model_id) return
      let self = this

      this['model/get']({
        account_id: self.$route.params.account_id,
        model_id: model_id,
        callback: res => {
          if (res.error) {
            console.error(res.error)
          } else {
            this.model_intents = res.resource.Intents.slice()
            this.model_entities = res.resource.Entities.slice()
          }
        }
      })
    },
    modelSelected (element_attribute, value) {
      let intent = this.getAttribute('intent')
      if (intent) {
        this.updateElementAttributeNow(intent, '')
      }

      let entities = this.getAttribute('entities')
      if (entities) {
        this.updateElementAttributeNow(entities, '')
      }

      this.updateElementAttributeNow(element_attribute, value)
      this.getModel(value)
    },
    addEntity (entity) {
      if (!entity) return
      let entitiesArray = this.Entities.slice()
      let exists = entitiesArray.find(e => e.entity == entity)
      if (!exists) {
        entitiesArray.push({
          entity: entity,
          user_attribute_id: ''
        })

        let entities = this.getAttribute('entities')
        if (entities) {
          this.updateElementAttributeNow(entities, JSON.stringify(entitiesArray))
        }
      }

      this.$nextTick(() => {
        this.selected_entity = null
      })
    },
    removeEntity (entity) {
      let entitiesArray = this.Entities.slice()
      let index = entitiesArray.findIndex(e => e.entity == entity)
      if (index >= 0) {
        entitiesArray.splice(index, 1)
        let entities = this.getAttribute('entities')
        if (entities) {
          this.updateElementAttributeNow(entities, JSON.stringify(entitiesArray))
        }
      }
    },
    updateEntity (entity, value) {
      let entitiesArray = this.Entities.slice()
      let index = entitiesArray.findIndex(e => e.entity == entity)
      if (index >= 0) {
        entitiesArray.splice(index, 1, {
          entity: entity,
          user_attribute_id: value
        })

        let entities = this.getAttribute('entities')
        if (entities) {
          this.updateElementAttributeNow(entities, JSON.stringify(entitiesArray))
        }
      }
    }
  },
  created () {
    this.updateElementAttribute = _debounce((element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }, 2000, {leading: false, trailing: true})

    this.updateElementAttributeNow = (element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }
  },
  mounted () {
    let modelId = this.getAttribute('model_id')
    if (modelId) {
      this.getModel(modelId.value)
    }
  },
  components: {
    'k-select': Select,
    'template-element-connector': Connector
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .ai-nlp-element {

    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    .entity-element {
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
  }
</style>
